var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.667 4)",
    fill: "#02607F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.783 0c2.208 0 3.997 1.755 3.997 3.92 0 2.164-1.79 3.92-3.997 3.92a4.057 4.057 0 0 1-1.456-.269c1.49-.57 2.543-1.99 2.543-3.651 0-1.661-1.054-3.081-2.541-3.652.45-.173.94-.268 1.454-.268z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.417,
    cy: 3.92,
    rx: 3.997,
    ry: 3.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 8.96c2.53 0 4.575 2.006 4.575 4.498v2.787a.562.562 0 0 1-.566.555h-2.91c.311 0 .565-.25.565-.555v-2.787c0-2.492-2.045-4.497-4.575-4.497z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.26 8.96H4.586C2.057 8.96 0 10.978 0 13.459v2.787c0 .306.254.555.566.555h13.702c.312 0 .566-.25.566-.555v-2.787c0-2.492-2.045-4.497-4.575-4.497z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-status-active.aca6e9734790a4ddf40fb6db7b36b501.svg";